import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import { SecondaryTabsBar } from 'components/shared/SecondaryTabsBar/SecondaryTabsBar'
import { Trait } from '../Trait/Trait'
import { personalityOverviewTab } from '../../model'
import styles from './PersonalityFactors.module.scss'
import { PersonalityOverview } from './PersonalityOverview/PersonalityOverview'
import { hasCaution } from '../cautions'

export const PersonalityFactors = ({
  language,
  factors,
  scores,
  personalityTab,
  setPersonalityTab,
  selectedCandidates,
  setSelectedCandidates,
  response,
  candidates,
  name,
  cautions = [],
  className,
  align = 'center',
}) => {
  const tabConfig = factors.find(({ id }) => id === personalityTab)
  const factor = tabConfig?.factor
  const overviewTab = personalityOverviewTab()
  const single = candidates.length === 1

  return (
    <Box
      align={align}
      direction="column"
      className={cx(styles.personailty, className)}
    >
      <SecondaryTabsBar
        tabs={[
          overviewTab,
          ...factors.map(({ label, id, factor }) => ({
            id,
            label,
            caution: hasCaution(cautions, factor) ? 1 : 0,
          })),
        ]}
        activeTab={personalityTab}
        setActiveTab={setPersonalityTab}
      />
      {personalityTab === overviewTab.id ? (
        <PersonalityOverview
          {...{
            factors,
            language,
            single,
            response,
            scores,
            candidates,
            selectedCandidates,
            setSelectedCandidates,
            setPersonalityTab,
            name,
            cautions,
          }}
        />
      ) : (
        <Trait
          key={factor}
          groups={tabConfig?.groups}
          {...{
            factor,
            language,
            scores,
            name,
            single,
            response,
            selectedCandidates,
            setSelectedCandidates,
            candidates,
            cautions,
          }}
        />
      )}
    </Box>
  )
}
